// extracted by mini-css-extract-plugin
module.exports = {"productCard":"VIP_ProductCard__productCard","eye-icon":"VIP_ProductCard__eye-icon","eyeIcon":"VIP_ProductCard__eye-icon","coreIcon":"VIP_ProductCard__coreIcon"};